


import React, { useEffect, useState , useMemo} from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const StackedBarChart = ({barDataPin, from}) => {
  const [days, setDays] = useState([]);
  const [successCounts, setSuccessCounts] = useState([]);
  
  const [failCounts, setFailCounts] = useState([]);
  const [pendingCounts, setPendingCounts] = useState([]);
  const [totalRupees, setTotalRupees] = useState([]);

 
  const memoizedData = useMemo(() => {
    let successCount = 0;
    let failCount = 0;
    let pendingCount = 0;
    let dayTotalRupees = 0;
    let allDays = [];
    let successCountsTemp = [];
    let failCountsTemp = [];
    let pendingCountsTemp = [];
    let totalRupeesTemp = [];

    if (barDataPin !== undefined && barDataPin !== null && Array.isArray(barDataPin)) {
      barDataPin.forEach((entry) => {
        allDays.push(`${entry?.date}`);

        successCount = 0;
        failCount = 0;
        pendingCount = 0;
        dayTotalRupees = 0;

        entry.data.forEach(item => {
          switch (item.id) {
            case "SUCCESS":
              successCount += item.count;
              dayTotalRupees = item.amount;
              break;
            case "FAILED":
              failCount += item.count;
              break;
            case "PENDING":
              pendingCount += item.count;
              break;
            default:
              break;
          }
        });

        successCountsTemp.push(successCount);
        failCountsTemp.push(failCount);
        pendingCountsTemp.push(pendingCount);
        totalRupeesTemp.push(dayTotalRupees);
      });
    }

    return {
      allDays,
      successCounts: successCountsTemp,
      failCounts: failCountsTemp,
      pendingCounts: pendingCountsTemp,
      totalRupees: totalRupeesTemp,
    };
  }, [barDataPin]);

  useEffect(() => {
    setDays(memoizedData.allDays);
    setSuccessCounts(memoizedData.successCounts);
    setFailCounts(memoizedData.failCounts);
    setPendingCounts(memoizedData.pendingCounts);
    setTotalRupees(memoizedData.totalRupees);
  }, [memoizedData]);

  const totalCounts = successCounts.map((count, i) => count + failCounts[i] + pendingCounts[i]);
  const successPercentage = successCounts.map((count, i) => (count / totalCounts[i]) * 100);
  const failPercentage = failCounts.map((count, i) => (count / totalCounts[i]) * 100);
  const pendingPercentage = pendingCounts.map((count, i) => (count / totalCounts[i]) * 100);

  // Calculate rupee segments
  const successRupees = totalRupees.map((rupees, i) => (rupees * successPercentage[i]) / 100);
  const failRupees = totalRupees.map((rupees, i) => (rupees * failPercentage[i]) / 100);
  const pendingRupees = totalRupees.map((rupees, i) => (rupees * pendingPercentage[i]) / 100);

  // Prepare the data for the chart

  const data = {
    labels: days,
    datasets: [
      {
        label: 'Success',
        data: successRupees,
        backgroundColor: "#61bd6d",
      },
      {
        label: 'Fail',
        data: failRupees,
        backgroundColor: '#d9534f',
      },
      {
        label: 'Pending',
        data: pendingRupees,
        backgroundColor:  '#f0ad4e',
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const index = context.dataIndex;
            const successLabel = `Success: ${successPercentage[index].toFixed(1)}%`;
            const failLabel = `Fail: ${failPercentage[index].toFixed(1)}%`;
            const pendingLabel = `Pending: ${pendingPercentage[index].toFixed(1)}%`;
            return [successLabel, failLabel, pendingLabel];
          },
        },
      },
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '',
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: 'Success Amount',
        },
      },
    },
  };

  return(
    <div style={{ width: '100%', height: '300px', display:'flex', justifyContent:'center' }}>
     <Bar   data={data} options={options} />
    </div>
  )
   
};

export default StackedBarChart;
